import 'core-js/stable';
import { createStore } from 'vuex';
import state from './state.js';
import mutations from './mutations.js';
import actions from './actions.js';
import ES6Promise from 'es6-promise';
import commonStore from './common';
import productStore from './modules/product';
import logStore from './modules/logs';
import authStore from './modules/auth.js';
import productTypeStore from './modules/product-type';
import metricStore from './modules/metric';
import event from './event';
import notify from './modules/notify';
import alarmStore from './modules/alarm';
import searchStore from './modules/search';
import dashboardStore from '@/store/modules/dashboard';
import chartPopupStore from '@/store/modules/chartPopup';

ES6Promise.polyfill();
export const store = createStore({
  state,
  mutations,
  actions,
  getters: {
    getParameters: (state) => (key) => {
      return state.params[key] || {};
    }
  },
  modules: {
    commonStore: commonStore,
    eventState: event,
    productStore,
    logStore,
    authStore,
    productType: productTypeStore,
    metric: metricStore,
    notify,
    alarmStore,
    searchStore,
    chartPopup: chartPopupStore,
    dashboardState: dashboardStore
  }
});

export default store;
